import { organisation } from '../../data/mockData';
import { ButtonLink } from '../ui/Button';
import ImageCarousel from './ImageCarousel';

// Import carousel images
import headerImage1 from '../../assets/header-image-1.jpg';
import headerImage2 from '../../assets/header-image-2.jpg';
import headerImage3 from '../../assets/header-image-3.jpg';

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* Background carousel */}
      <div className="absolute inset-0 -z-10">
        <ImageCarousel
          images={[headerImage1, headerImage2, headerImage3]}
          interval={5000}
          className="h-full rounded-none"
        />
        {/* Dark overlay for text contrast */}
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/75 to-white/10" />
      </div>

      <div className="container relative z-10 grid items-center gap-14 py-16 lg:grid-cols-2 lg:py-24">
        <div className="animate-fade-up">
          <span className="eyebrow">
            <span className="h-1.5 w-1.5 rounded-full bg-flare-400" />
            MICT SETA accredited &middot; {organisation.accreditationNumber}
          </span>

          <h1 className="mt-5 text-4xl leading-[1.08] text-balance sm:text-5xl lg:text-display-lg">
            Build a career in IT with an accredited qualification
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-brand-900/65">
            Mokaleng IT runs SAQA-registered learnerships and vendor
            certifications in technical support, systems development, and
            systems support. Practical training, national recognition, real work
            readiness.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-3">
            <ButtonLink to="/learnerships" variant="primary" size="lg">
              View learnerships
              <svg
                className="h-4 w-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M5 12h14" />
                <path d="m13 6 6 6-6 6" />
              </svg>
            </ButtonLink>
            <ButtonLink to="/apply" variant="secondary" size="lg">
              How to apply
            </ButtonLink>
          </div>

          <dl className="mt-10 grid max-w-lg grid-cols-3 gap-6 border-t border-canvas-300 pt-7">
            {[
              { value: '4', label: 'Accredited learnerships' },
              { value: '6', label: 'Short programmes' },
              { value: '150+', label: 'Learners trained' },
            ].map((item) => (
              <div key={item.label}>
                <dt className="text-2xl font-extrabold text-brand-950">
                  {item.value}
                </dt>
                <dd className="mt-1 text-sm leading-snug text-brand-900/60">
                  {item.label}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
